import React, { useEffect, useState } from "react";
import "./Popular.css";
import Item from "../Item/Item";

const Popular = () => {
  const [popularProducts, setPopularProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsPerSlide, setItemsPerSlide] = useState(5);

  useEffect(() => {
    fetch("https://backend.mariemadeit.com/popularitems")
      .then((res) => res.json())
      .then((data) => {
        setPopularProducts(data);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <700) {
        setItemsPerSlide(2);
      } else if (window.innerWidth < 920) {
        setItemsPerSlide(2);
      } else if (window.innerWidth < 1350) {
        setItemsPerSlide(3);
      } else if (window.innerWidth < 1800) {
        setItemsPerSlide(4);
      } else {
        setItemsPerSlide(5);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (loading) {
    return null;
  }

  const groupedProducts = [];

  for (let i = 0; i < popularProducts.length; i += itemsPerSlide) {
    groupedProducts.push(popularProducts.slice(i, i + itemsPerSlide));
  }

  return (
    <div className="popular">
      <div className="popular-title">
        <h2>Best Sellers</h2>
        <p>Check out our most popular products!</p>
      </div>
      <div id="popular-carousel" className="carousel slide">
        <div className="carousel-inner">
          {groupedProducts.map((group, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <div className="carousel-row">
                {group.map((item) => (
                  <Item
                    key={item.id}
                    id={item.id}
                    name={item.name}
                    size={item.size}
                    color={item.color}
                    image={item.image_urls[0]}
                    new_price={item.new_price}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#popular-carousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" />
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#popular-carousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" />
        </button>
      </div>
    </div>
  );
};

export default Popular;
